export default __webpack_public_path__ + "static/media/marigold.b0992fbc.png";